import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWhatsapp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.33 3.45c-4.94 0-8.96 3.87-8.97 8.63 0 1.52.42 3 1.2 4.31l-1.27 4.48 4.75-1.2c1.32.69 2.8 1.05 4.28 1.05 4.95 0 8.97-3.88 8.97-8.64 0-2.3-.93-4.47-2.62-6.1a9.08 9.08 0 0 0-6.34-2.53Zm0 15.8a7.65 7.65 0 0 1-3.8-1l-.27-.15-2.82.72.75-2.65-.17-.27a6.96 6.96 0 0 1-1.14-3.82c0-3.96 3.34-7.18 7.45-7.18 1.99 0 3.86.75 5.27 2.1a7 7 0 0 1 2.18 5.08 7.33 7.33 0 0 1-7.45 7.18Zm4.08-5.37c-.22-.1-1.32-.62-1.53-.7-.2-.07-.35-.1-.5.11-.15.22-.58.7-.71.85-.13.14-.26.16-.49.05-.22-.1-.94-.34-1.8-1.07a6.5 6.5 0 0 1-1.24-1.5c-.13-.21-.02-.33.1-.43l.33-.38c.11-.13.15-.22.23-.36.07-.15.03-.27-.02-.38-.06-.1-.5-1.17-.7-1.6-.18-.42-.36-.36-.5-.37a10 10 0 0 0-.43 0c-.15 0-.39.04-.6.26-.2.22-.78.74-.78 1.8s.8 2.09.92 2.23c.1.14 1.58 2.32 3.82 3.26.54.22.95.35 1.28.45.53.17 1.02.14 1.4.09.44-.06 1.33-.52 1.52-1.03.19-.5.19-.93.13-1.02-.05-.1-.2-.15-.43-.26Z"
	})
});
export default SvgWhatsapp;
